import { LocalesEnum } from '../enums/LocalesEnum';
import { toArray } from './toArray';

export const mapToValues = (locale: LocalesEnum, rawName: LocalesEnum) => {
  return (
    {value, key, label, count}: { value: string, key: number, label: string, count: number },
  ) => {
    const labelObj = JSON.parse(label);
    const localized = toArray(labelObj?.[locale]?.length > 0 ? labelObj[locale] : labelObj[rawName]);
    return {
      value,
      label: localized[key] || value,
      count
    }
  };
};
